import { render, staticRenderFns } from "./IconInjection.vue?vue&type=template&id=b6e9e3c4&"
import script from "./IconInjection.vue?vue&type=script&lang=js&"
export * from "./IconInjection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports